import { Component, OnInit, ViewChild } from '@angular/core';
import { TABLES_CONFIG } from '@asambleas-env/environment';
import { ChurchService } from '@asambleas-services/church/church.service';
import { ActivatedRoute } from '@angular/router';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { User } from '@asambleas-models/user.model';

import * as moment from 'moment';
import { Angular5Csv } from 'angular5-csv/Angular5-csv';
import { Concept } from '@asambleas-models/concept.model';
import { GeneralService } from '@asambleas-services/general/general.service';
import { UserFeedbackService } from '@asambleas-modules/user-feedback/user-feedback.service';


@Component({
    selector: 'app-members-list',
    templateUrl: './members-list.component.html',
    styleUrls: ['./members-list.component.scss']
})
export class MembersListComponent implements OnInit {

    resourcesHasLoaded: boolean = false
    ROWS = TABLES_CONFIG.ROW_NUMBER

    churchID: string = '';
    allUsers: Array<User> = [];
    isData: boolean = true

    streetValues: any = [];

    displayedColumns = ['member', 'birthdate', 'phone', 'mail', 'type'];
    dataSource = new MatTableDataSource(this.allUsers);
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private _churchService: ChurchService,
        private activatedRoute: ActivatedRoute,
        private _feed: UserFeedbackService,
        private generalService: GeneralService
    ) {
        this.activatedRoute.params.subscribe((params: any) => {
            if (params.id) {
                this.churchID = params.id
            } else {
                this._feed.openSnackbar({
                    message: 'No se puede ubicar la iglesia.'
                })
            }
        })
    }

    ngOnInit() {
        this._churchService.getChurchMembers(this.churchID).subscribe(response => {
            this.allUsers = <Array<User>>response

            if(this.allUsers.length === 0) {
                this.isData = false
            }

            this.allUsers.forEach(user => {
                if (user['birthdate']) {
                    let age = moment(user['birthdate'], 'YYYY-MM-dd')
                    user['age'] = moment().diff(age, 'years')
                } else {
                    user['age'] = -1;
                }

            });

            this.dataSource = new MatTableDataSource(this.allUsers);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;

            this.resourcesHasLoaded = true
        })

        // Para escribir la dirección correctamente al exportar
        this.generalService.getConceptDataById(9).subscribe((data: Concept) => {
            this.streetValues = data.values
        })
    }

    downloadUsers() {
        csvOptions['headers'] = ['Nombre', 'Telefono', 'Direción de Residencia', 'Fecha de nacimiento', 'Email', 'Tipo de Usuario'];

        const csvMembers = this.dataSource.data.map((member) => {
            let address = member['residence_address'].split('?');
            let adr: string = '';

            if (address.length === 4) {
                adr = `${this.streetValues[Number(address[0])]['description']} ${address[1]} #${address[2]} - ${address[3]}`
            } else {
                if (address.length === 1) {
                    adr = address[0]
                }
            }

            return {
                name: `${member['name']} ${member['second_name']} ${member['surname']} ${member['second_surname']}`,
                phone: member['phone'],
                residence_address: adr,
                birthdate: member['birthdate'],
                email: member['email'],
                is_academic: member['is_academic'] ? 'Ministro' : 'Miembro',
            }
        })

        const data = new Angular5Csv(csvMembers, 'Miembros de La Iglesia', csvOptions);
    }

}

const csvOptions = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    headers: ['charset=UTF-8']
};



// WEBPACK FOOTER //
// ./src/app/admin/pages/iglesias/members-list/members-list.component.ts